import { render, staticRenderFns } from "./side_menu.vue?vue&type=template&id=a7ebb87a&lang=pug"
import script from "./side_menu.vue?vue&type=script&lang=js"
export * from "./side_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports